if (!customElements.get('comparison-popup')) {
    customElements.define('comparison-popup', class ComparisonPopup extends ModalDialog {
        constructor() {
            super();

            this.selectors = {
                cartDrawer: 'cart-drawer'
            };

            this.classes = {
                active: "is-active",
                simplePopup: 'subscription-popup--simple'
            };

            this.attrs = {
                shown: "data-shown",
                cartDrawerPopup: 'cart-drawer-popup'
            };

            this.hide = this.hide.bind(this);
            this.cartDrawer = document.querySelector(this.selectors.cartDrawer);
        }

        connectedCallback() {
            document.addEventListener('subscription-popup:hide:trigger', this.hide);
        }

        disconnectedCallback() {
            document.removeEventListener('subscription-popup:hide:trigger', this.hide);
        }

        hide() {
            if(this.isCartDrawerPopup(this)) {
                this.toggleCartDrawerPopup(null, false);
                return;
            }

            if (!this.hasAttribute('open')) return;

            super.hide();

            document.dispatchEvent(new CustomEvent('subscription-popup:hide'));
        }

        show(opener) {
            if(this.isCartDrawerPopup(opener)) {
                this.toggleCartDrawerPopup(opener, true);
                return;
            }

            super.show(opener);

            document.dispatchEvent(new CustomEvent('subscription-popup:show'));
        }

        isCartDrawerPopup(element) {
            return this.cartDrawer && element.dataset.type === this.attrs.cartDrawerPopup;
        }

        toggleCartDrawerPopup(opener, open) {
            switch (open) {
                case true:
                    this.openCartDrawerPopup = true;
                    this.cartDrawer.addEventListener('transitionend', () => {
                        if(this.openCartDrawerPopup) {
                            this.classList.add(this.classes.simplePopup);
                            this.dataset.type = this.attrs.cartDrawerPopup;
                            super.show(opener);
                            document.dispatchEvent(new CustomEvent('subscription-popup:show'));
                        }
                    }, { once: true });

                    this.cartDrawer.close();
                    break;
                case false:
                    this.openCartDrawerPopup = false;
                    super.hide();
                    document.dispatchEvent(new CustomEvent('subscription-popup:hide'));
                    this.classList.remove(this.classes.simplePopup);
                    this.dataset.type = "";
                    this.cartDrawer.open();
                    break;
            }
        }
    });
}